import ReactQueryProvider from './react-query-provider.component'

export default ReactQueryProvider
